import { formatEndpoint } from '@frontend/duck-tape';

const namespace = 'system';

export const IMAGEKIT_AUTHENTICATION = 'imagekit_authentication';
export const ADDRESS_AUTOCOMPLETE = 'places/autocomplete';
export const ADDRESS_DETAILS = 'places/details';

export const SYSTEM_ENDPOINTS = {
  addressAutocomplete: formatEndpoint(ADDRESS_AUTOCOMPLETE, namespace),
  addressDetails: formatEndpoint(ADDRESS_DETAILS, namespace),
  authenticateImageKit: formatEndpoint(IMAGEKIT_AUTHENTICATION, namespace),
};
